import React from "react";
import { LeadLink } from "web/react/components/lead-link";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { Text } from "web/react/emo/text";
import { sendAnalyticsEvent } from "web/react/pages/product/out-of-stock/out-of-stock-product-page/utils";
import { ProductBuyOptionsSerializer } from "web/types/serializers";
import * as styles from "./last-seen-time-callout.css";

interface LastSeenTimeCalloutProps {
    productId: string;
    mainBuyOption: ProductBuyOptionsSerializer;
    isCheckout?: boolean;
}

export function LastSeenTimeCallout({
    productId,
    mainBuyOption,
    isCheckout,
}: LastSeenTimeCalloutProps): React.ReactElement {
    const eventCustomData = {
        buy_option_id: mainBuyOption.link_id.toString(),
        product_id: productId,
        retailer_slug: mainBuyOption.retailer_slug,
    };

    return (
        <>
            {!isCheckout ? (
                <div className={styles.lastSeenTimeContainer}>
                    <LeadLink
                        href={mainBuyOption.affiliate_url}
                        reason="last-seen-time-link"
                        rel="noopener noreferrer"
                        className={styles.lastSeenLink}
                        productId={productId}
                        openInNewTab
                        eventAction="click"
                        eventCategory="oos-product-hero"
                        eventLabel={"affiliate-buy-on-store-last-seen-link"}
                        eventCustomData={eventCustomData}
                    >
                        <Text textStyle={"body-bold"} as="span">
                            {mainBuyOption.last_seen_in_stock}
                            <SVGIcon
                                name="external-link"
                                overrideStyle
                                className={styles.lastSeenLinkIcon}
                            />
                        </Text>
                    </LeadLink>
                </div>
            ) : (
                <div className={styles.lastSeenTimeContainer}>
                    <a
                        href={mainBuyOption.retailer_link}
                        rel="noopener noreferrer"
                        className={styles.lastSeenLink}
                        onClick={() =>
                            sendAnalyticsEvent(
                                "oos-product-hero",
                                "click",
                                "checkout-last-seen-link",
                                true,
                                eventCustomData
                            )
                        }
                    >
                        <Text textStyle={"body-bold"} as="span">
                            {mainBuyOption.last_seen_in_stock}
                        </Text>
                    </a>
                </div>
            )}
        </>
    );
}
